const HOST = 'https://gateway.s5.ottomatically.com/api/v1';
// const HOST = 'https://linked-things-s4-gateway.eu-de.mybluemix.net/api/v1';
// const HOST = 'http://175.107.196.247:3000/api/v1';

export default {
    HOST
}